import { coreTranslations } from "./i18n-core";

export type Language = "tr" | "en" | "ru";

// Start with core (homepage) translations; full dict loads lazily
let allTranslations: Record<string, Record<string, string>> = coreTranslations;
let fullLoaded = false;
let loadPromise: Promise<void> | null = null;

/**
 * Lazily loads the full translation dictionary.
 * Returns immediately if already loaded.
 */
export function loadFullTranslations(): Promise<void> {
  if (fullLoaded) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = import("./i18n-data").then((mod) => {
    allTranslations = mod.translations;
    fullLoaded = true;
  });

  return loadPromise;
}

// For backwards compatibility — typed key access
export type TranslationKey = string;

export function t(key: string, lang: Language, params?: Record<string, string | number>): string {
  const entry = allTranslations[key];
  const val = entry?.[lang] || entry?.["tr"] || key;
  if (!params) return val;
  return Object.entries(params).reduce((s, [k, v]) => s.replace(`{${k}}`, String(v)), val);
}

export function getStoredLanguage(): Language {
  if (typeof window === "undefined") return "tr";
  return (localStorage.getItem("biletime-lang") as Language) || "tr";
}

export function setStoredLanguage(lang: Language) {
  localStorage.setItem("biletime-lang", lang);
}

export interface I18nContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}
